module.exports = __webpack_public_path__ + "static/media/icon-support-2.a10d6477.svg";